module.exports = __webpack_public_path__ + "img/trash.8f4563d2.svg";